import React from 'react';
import {Route, IndexRoute, Redirect} from 'react-router';

import App from './components/App';
import IndexPage from './pages/IndexPage';
import Socials from './pages/Socials';
import UsernameLogin from './pages/UsernameLogin';
import OtherSocials from './pages/OtherSocials';
import AuthRegistration from './pages/Registration';
import AuthResetPassword from './pages/ResetPassword';
import AuthSetPassword from './pages/SetPassword';
import AuthAsk from './pages/Ask';
import Verification from './pages/Verification';
import Terms from './pages/Terms';
import Conditions from './pages/Conditions';
import Page404 from './pages/404';
import Page500 from './pages/500';
import OTP from './pages/OTP';
import Agreement from './pages/Agreement';

export default (
  <Route>
    <Route name="app" component={App} path="/">
      <IndexRoute component={IndexPage} />

      <Route component={Socials} path="socials" />
      <Route component={UsernameLogin} path="username-login" />
      <Route component={OtherSocials} path="other" />
      <Route component={OtherSocials} path="other/noemail" onlySocials={true} />
      <Route component={AuthRegistration} path="registration" />
      <Route component={AuthResetPassword} path="reset-password" />
      <Route component={AuthSetPassword} path="set-password" />
      <Route component={AuthAsk} path="ask" />
      <Route component={OTP} path="otp" />
    </Route>

    <Route name="verification" component={Verification} path="/verification" />
    <Route name="terms" component={Terms} path="/terms" />
    <Route name="conditions" component={Conditions} path="/conditions" />
    <Route component={Page404} path="/404" />
    <Route component={Page500} path="/500" />
    <Route component={Agreement} path="/agreement" />

    <Redirect from="*" to="/404" />
  </Route>
);



// WEBPACK FOOTER //
// ./routes.jsx